import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertComponent } from '../../alert/alert.component';
import { AuthService } from '../../services/core/auth.service';
import * as _ from "lodash";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  @ViewChild(AlertComponent)
  private alert: AlertComponent;
  f = {
    username: null,
    password: null
  };
  type: string = 'password'
  returnUrl: string = '/home';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private auth: AuthService
  ) { }

  ngOnInit() {
    //console.log("route: "+JSON.stringify(this.route.queryParamMap));
    this.route.queryParams.subscribe(params => {
      console.log("param: " + params['returnUrl']);
      this.returnUrl = params['returnUrl'] ? params['returnUrl'] : "/home";
    });
  }
  onShowHide() {
    this.type = this.type == 'password' ? 'text' : 'password';
  }

  doLogin() {
    //console.log("values: " + JSON.stringify(this.f));
    if (_.isNull(this.f.username) || _.isNull(this.f.password) || _.isEmpty(this.f.username) || _.isEmpty(this.f.password)) {
      this.alert.show("Required fields", "danger");
    } else {
      this.auth.login(this.f.username, this.f.password).then(r => {
        let u = r.json();
        //console.log("login: " + JSON.stringify(u));
        this.auth.setUser(u);
        this.router.navigate([this.returnUrl ? this.returnUrl : 'home']);
      }, e => {
        //console.log("login-error: " + JSON.stringify(e));
        this.alert.show("" + e.status + ' - ' + e.statusText, 'danger');
      }).catch(e => {
        //console.log("login-catch-error: " + e);
        this.alert.show("Exception: " + e, 'danger');
      });
    }
  }

}



// WEBPACK FOOTER //
// /Users/eduar.doramirez/developer/code/edd/ceramicamx/web/cmx-catalog/src/app/pages/login/login.component.ts